<template>
  <div id="SupplierDetail">
    <eb-header>
      <eb-break-crumb slot="breakCrumb"/>
    </eb-header>
    <div class="card-box">
      <OrgSupplierCard @addSupplierSuccess="onSuccess" :orgInfo="orgSupplierInfo"/>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <OrgViewInfo class="viewSummary" :orgInfo="orgSupplierInfo" :user="user"/>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <OrgViewTradeArea :orgInfo="orgSupplierInfo"/>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <OrgViewQualification :orgAptitudeFileArr="orgAptitudeFileArr"/>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <OrgViewTeam :companyTeamList="companyTeamList"/>
    </div>
    <div class="eb-line" v-if="orgSupplierInfo.isSupplier === '1'"></div>
    <div class="panel-box" v-if="orgSupplierInfo.isSupplier === '1'">
      <eb-panel>
        <eb-panel-header class="panel-header" slot="header">
          <span slot="title">供应商信息</span>
        </eb-panel-header>
        <div slot="body">
          <div class="panel-body-row">
            <div class="panel-body-row-left">供应商编码:</div>
            <div class="panel-body-row-right">{{orgSupplierInfo.supplierCode}}</div>
          </div>
          <div class="panel-body-row">
            <div class="panel-body-row-left">供应商级别:</div>
            <div class="panel-body-row-right">{{orgSupplierInfo.companyLevel | companyLevel}}</div>
          </div>
          <div class="panel-body-row">
            <div class="panel-body-row-left projectInfo">添加时间:</div>
            <div
              class="panel-body-row-right"
            >{{orgSupplierInfo.createTime | dateTimeStandardFormatZh}}</div>
          </div>
          <div class="panel-body-row">
            <div class="panel-body-row-left projectInfo">供应商备注:</div>
            <div class="panel-body-row-right">{{orgSupplierInfo.purchaseLabel}}</div>
          </div>
        </div>
      </eb-panel>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <OrgViewCooperation :orgCooperation="orgSupplierInfo"/>
    </div>
  </div>
</template>

<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import OrgSupplierCard from '@/components/org/view/OrgSupplierCard';
import OrgViewInfo from '@/components/org/view/OrgViewInfo';
import OrgViewTradeArea from '@/components/org/view/OrgViewTradeArea';
import OrgViewQualification from '@/components/org/view/OrgViewQualification';
import OrgViewTeam from '@/components/org/view/OrgViewTeam';
import OrgViewCooperation from '@/components/org/view/OrgViewCooperation';
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import { getOrgSupplierInfo, listDepartFile } from '@/services/org/depart-service';
import { getUserByIds } from '@/services/user/user-service';
export default {
  components: {
    ebHeader,
    ebPanel,
    ebPanelHeader,
    ebBreakCrumb,
    OrgSupplierCard,
    OrgViewInfo,
    OrgViewTradeArea,
    OrgViewQualification,
    OrgViewTeam,
    OrgViewCooperation
  },
  data() {
    return {
      supplierOrgId: this.$route.params.supplierOrgId,
      user: this.$store.state.user.userInfo,
      orgSupplierInfo: {},
      companyTeamList: [],
      orgAptitudeFileArr: []
    };
  },
  created() {
    this.initOrgSupplierInfo();
    this.loadOrgAptitudeFile();
  },
  methods: {
    async initOrgSupplierInfo() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await getOrgSupplierInfo(this.supplierOrgId);
        if (data.returnCode === '01') {
          this.orgSupplierInfo = data.orgInfo;
          this.loadOrgTeamMember(this.orgSupplierInfo.companyTeam);
        } else if (data.returnCode === '00') {
        } else {
          this.$message.error('获取信息失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    async loadOrgTeamMember(companyTeam) {
      if (companyTeam == null || companyTeam === '') {
        this.companyTeamList = [];
        return;
      }
      let orgUserIdArr = companyTeam && companyTeam !== '' ? companyTeam.split(',') : ['', '', '', '', ''];
      let orgUserIds = companyTeam.split(',').filter(function(userId) {
        return userId !== '';
      }).join(',');
      if (orgUserIds === '') {
        this.companyTeamList = [];
        return;
      }
      try {
        let { data } = await getUserByIds(orgUserIds);
        if (data.returnCode === '01') {
          this.companyTeamList = data.userList;
          let companyTeamListTemp = [];
          let orgUserIdArrLen = orgUserIdArr.length;
          let userListLen = data.userList.length;
          for (let i = 0; i < orgUserIdArrLen; i++) {
            for (let j = 0; j < userListLen; j++) {
              let orgUserId = orgUserIdArr[i];
              let userId = data.userList[j]['userId'].toString();
              if (orgUserId === userId) {
                companyTeamListTemp.push(data.userList[j]);
              }
            }
          }
          this.companyTeamList = companyTeamListTemp;
        } else {
          this.$message.error('加载机构团队成员信息失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async loadOrgAptitudeFile() {
      let orgId = this.supplierOrgId;
      try {
        let { data } = await listDepartFile(orgId);
        if (data.returnCode === '01') {
          this.orgAptitudeFileArr = data.data;
        } else {
          this.$message.error('加载企业资质文件失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    onSuccess: function() {
      this.initOrgSupplierInfo();
    }
  }
};
</script>

<style  scoped lang="less">
.panel-body-row .panel-body-row-left {
  width: 15%;
}
.card-box {
  padding: 30px 0 30px 0;
}
</style>
